export default __webpack_public_path__ + "static/media/performance.b392bed6.svg";